<template>
  <div
    v-if="spinControlPanelStatus"
    class="spin-buttons"
    :style="{'position': position, 'background': background}"
  >
    <SpinMaterialButtons v-if="spinControlSelectedIconsStyle === 'material'" />
    <SpinFlaticonButtons v-if="spinControlSelectedIconsStyle === 'flat'" />
    <SpinFontawesomeButtons v-if="spinControlSelectedIconsStyle === 'fontawesome'" />
  </div>
</template>

<script>
import SpinMaterialButtons from '@/widgets/common/SpinMaterialButtons'
import SpinFlaticonButtons from '@/widgets/common/SpinFlaticonButtons'
import SpinFontawesomeButtons from '@/widgets/common/SpinFontawesomeButtons'
import { mapGetters } from 'vuex'
export default {
  name: 'SpinButtons',
  components: {
    SpinMaterialButtons,
    SpinFlaticonButtons,
    SpinFontawesomeButtons
  },
  computed: {
    ...mapGetters({
      spinControlSelectedIconsStyle: 'spinControl/spinControlSelectedIconsStyle',
      spinControlSelectedPosition: 'spinControl/spinControlSelectedPosition',
      spinControlPanelStatus: 'spinControl/spinControlPanelStatus',
      spinControlBackground: 'spinControl/spinControlBackground'
    }),
    position() {
      return this.spinControlSelectedPosition === 'onspin' ? 'absolute' : 'relative'
    },
    background() {
      return this.spinControlBackground
    }
  }
}
</script>

<style lang="scss" scoped>
.spin-buttons {
  width: 100%;
  bottom: 0;
  min-height: 80px;
  background-color: rgba(50, 123, 186, .15);
  z-index: 2;
}
</style>
